import React from 'react'

const Background = () => (
    <div className="bg">
        <div className="bg_skewed">
            <div className="unskewed" />
        </div>
    </div>
)

export default Background
